<script>
import AuditOperatorBtnGroup from './AuditOperatorBtnGroup'

const DELETE_COMMENTS = [{
  id: 'P< (系统停电，数据无效)',
  flag: 'P<'
}, {
  id: 'D< (通道关闭、原始数据部分缺失，数据无效)',
  flag: 'D<'
}, {
  id: 'B< (仪器维护过，数据无效)',
  flag: 'B<'
}, {
  id: 'C< (仪器有校准，数据无效)',
  flag: 'C<'
}, {
  id: 'H< (数据超量程上限，数据无效)',
  flag: 'H<'
}, {
  id: 'L< (数据超量程下限，数据无效)',
  flag: 'L<'
}, {
  id: 'M< (维护, 数据无效)',
  flag: 'M<'
}, {
  id: '其它',
  flag: 'I',
  showTextArea: true
}]

export const deleteCommentMap = Object.freeze(DELETE_COMMENTS.reduce((map, comment) => {
  map[comment.id] = comment.flag
  return map
}, {}))

const RESERVE_COMMENTS = [{
  id: 'P> (系统停电，但是数据有效)',
  flag: 'P>'
}, {
  id: 'D> (通道关闭、原始数据部分缺失，但是数据有效)',
  flag: 'D>'
}, {
  id: 'B> (仪器维护过，但是数据有效)',
  flag: 'B>'
}, {
  id: 'C> (仪器有校准，但是数据有效)',
  flag: 'C>'
}, {
  id: 'H> (数据超量程上限，但是数据有效)',
  flag: 'H>'
}, {
  id: 'L> (数据超量程下限，但是数据有效)',
  flag: 'L>'
}, {
  id: 'M> (维护，数据有效)',
  flag: 'M>'
}, {
  id: '其它',
  flag: 'V',
  showTextArea: true
}]

export const reserveCommentMap = Object.freeze(RESERVE_COMMENTS.reduce((map, comment) => {
  map[comment.id] = comment.flag
  return map
}, {}))

export default {
  name: 'AuditOperatorBtnGroup3D',
  extends: AuditOperatorBtnGroup,
  computed: {
    reserveComments: () => RESERVE_COMMENTS,
    deleteComments: () => DELETE_COMMENTS
  }
}
</script>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditOperatorBtnGroup3D.vue